<template>
  <View direction="column" padding-block="sm" padding-inline="md" class="trace-panel">
    <Text variant="body-small" color="primary" class="body">{{ chip.body }}</Text>

    <View v-if="chip.parts.length" direction="column" gap="xs" class="parts">
      <Text v-for="(part, index) in chip.parts" :key="index" variant="body-small" as="div" color="primary" class="part">
        <b>{{ part.label }}</b>
        <!-- The dash carries its own spacing inside the mustache: Vue drops the whitespace-only
             text node between two elements, which is what ate the space and left "Move-in date—". -->
        <span v-if="part.detail">{{ ` — ${part.detail}` }}</span>
      </Text>
    </View>
  </View>
</template>

<script setup lang="ts">
import { Text, View } from '@tallo/design-system';

import { TraceChip } from '../traces/synthesize-trace-chip.function';

defineProps<{ chip: TraceChip }>();
</script>

<style scoped lang="scss">
.trace-panel {
  margin: var(--t-spacing-xs) 0 var(--t-spacing-sm);
  background: var(--t-color-neutral-50);
  border: 1px solid var(--t-color-border-secondary);
  border-radius: var(--t-border-radius-md);
  max-width: 58ch;
}

.body {
  margin: 0;
  // Deliberately between body-sm and body-md: the panel is a dense aside under a message, so it
  // reads a notch smaller than the message body but needs a looser leading than the token pairs
  // with 0.75rem to stay readable across several lines.
  font-size: 0.8125rem;
  line-height: 1.55;
}

.parts {
  margin-top: var(--t-spacing-sm);
  padding-top: var(--t-spacing-sm);
  border-top: 1px dashed var(--t-color-border-secondary);
}

.part {
  line-height: 1.5;

  b {
    font-weight: 600;
    color: var(--t-color-grey-700);
  }
}
</style>
